import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { network } from "../AdminNetwork"
import Market from "../../ABI/market";
import config from "../../lib/config"
import Web3 from "web3";
import { toastAlert } from '../../lib/toastAlert';
import {wallet_connect_context} from "../../actions/redux/action";

const EditServiceFee = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const Wallet_Details = useSelector((state) => state.admin);

    const [UserAccountAddr, Set_UserAccountAddr] = useState('')
    const [Accounts, Set_Accounts] = useState('')
    const [owner_Get, set_Owner_Get] = useState('')

    const [modalOpen, setmodalopen] = useState(false)

    const [ServiceDisable, setServiceDisable] = useState('start')
    const [ServiceDisable1, setServiceDisable1] = useState('init')
    const [seller__fee, set_seller__fee] = useState(0)
    const [buyer__fee, set_buyer__fee] = useState(0)

    useEffect(() => {
        getConnect();
        getserviceFee();

    }, [
        Wallet_Details?.UserAccountAddr,
        Wallet_Details?.networkConfiguration?.Chainid,
    ])

    const getConnect = async () => {
        try {
            var configdata = {};
            if (window.ethereum) {
                var web3 = new Web3(window.ethereum);
                if (web3 !== undefined) {
                    await window.ethereum.enable().then(async function () {
                        const web3 = new Web3(window.web3.currentProvider);
                        if (window.web3.currentProvider.networkVersion === config.ETH_ID) {
                            var currentChainId = network.ETH.Chainid;
                            configdata = network.ETH;
                        } else if (window.web3.currentProvider.networkVersion === config.MATIC_ID) {
                            var currentChainId = network.MATIC.Chainid;
                            configdata = network.MATIC;
                        } else if (window.web3.currentProvider.networkVersion === config.CAM_ID) {
                            var currentChainId = network.CAM.Chainid;
                            configdata = network.CAM;
                        }
                        if (window.web3.currentProvider.networkVersion == currentChainId) {
                            if (window.web3.currentProvider.isMetaMask === true) {
                                var currAddr1 = await web3.eth.getAccounts();
                                    var CurAddr = currAddr1[0].toLowerCase();
                                if (
                                    window.web3 &&
                                    CurAddr) {
                                   
                                
                                    Set_UserAccountAddr(CurAddr);
                                    var result = await web3.eth.getAccounts();
                                    var setacc = result[0];
                                    Set_Accounts(setacc);
                                    dispatch(wallet_connect_context({
                                        UserAccountAddr: setacc,
                                        WalletConnected: "true",
                                        Accounts: setacc,
                                        providerss: web3._provider,
                                        networkConfiguration: configdata,
                                    }));
                                }
                            }
                        } else {
                            toastAlert("upload", "Please Connect Wallet");
                        }
                    });
                }
            }
        } catch (errr) {
            console.log("get connect", errr);
        }
    };

    const getserviceFee = async () => {
      
        if (Wallet_Details?.networkConfiguration?.TradeContract) {
            try {
                var web3 = new Web3(Wallet_Details?.networkConfiguration?.BNBPROVIDER);

                var Contract = await new web3.eth.Contract(
                    Market,
                    Wallet_Details?.networkConfiguration?.TradeContract
                );

                var ownerGet = await Contract.methods.owner().call();
                var ownget = String(ownerGet).toLowerCase();
                set_Owner_Get(ownget);
                var resp = await Contract.methods.getServiceFee().call();
                if (resp) {
                    var web3 = new Web3(Wallet_Details.providerss);

                    var feeDetails = {
                        buyerFee: web3.utils.fromWei(String(resp[0]), "ether"),
                        sellerFee: web3.utils.fromWei(String(resp[1]), "ether"),
                    };
                    if (feeDetails) {
                        set_buyer__fee(feeDetails.buyerFee);
                        set_seller__fee(feeDetails.sellerFee);
                    }
                }
            } catch (err) {
                console.log("servicefee err", err);
            }
        }
    };

    const onChangeFUnc = async (e) => {
        var val = e.target.id
        setServiceDisable('start')
        switch (val) {

            case 'servicefeecheck1':
                if (e.target.value < 10 || e.target.value > 0) {
                    set_seller__fee(e.target.value)
                }
                else {
                    set_seller__fee(0)
                    setServiceDisable1('error')
                }
                break;
            case 'servicefeecheck':
                if (e.target.value < 10 || e.target.value > 0) {
                    set_buyer__fee(e.target.value)
                }
                else {
                    set_buyer__fee(0)
                    setServiceDisable1('error')
                }
                break;
        }


    }

    const changeNetwork = async () => {
        if (window.ethereum.isMetaMask == true) {
            var web3 = new Web3(window.ethereum);
            var networkConfiguration = "";
            var web3Obj = await SwitchNetwork();

            const accounts = await web3Obj.eth.getAccounts();

            if (accounts != "") {
                const IDcheck = await web3.eth.getChainId();

                if (IDcheck === network.MATIC.Chainid) {
                    networkConfiguration = network.MATIC;
                } else if (IDcheck === network.ETH.Chainid) {
                    networkConfiguration = network.ETH;
                } else if (IDcheck === network.CAM.Chainid) {
                    networkConfiguration = network.CAM;
                }
                dispatch(wallet_connect_context({
                    UserAccountAddr: accounts,
                    WalletConnected: "true",
                    Accounts: accounts,
                    providerss: web3Obj._provider,
                    networkConfiguration: networkConfiguration,
                }));
            }

            setTimeout(() => {
                window.location.reload();
            }, 5000);
        }
    };

    async function SwitchNetwork() {
        var web3;
        try {
            if (window.ethereum) {
                web3 = new Web3(window.ethereum);
                if (window.ethereum.isMetaMask == true) {
                    const chainId = await web3.eth.getChainId();
                    var configchainid = chainId === network.ETH.Chainid
                    ? network.MATIC.Chainid 
                    : chainId === network.MATIC.Chainid ? network.CAM.Chainid : network.ETH.Chainid;
                    if (parseInt(chainId) != parseInt(configchainid)) {
                        chainIdCheck(configchainid);
                        return web3;
                    }
                } else {
                    alert("Please Uninstall CoinbaseWallet or Connect to Coinbase");
                    return false;
                }
            } else {
            }
        } catch (e) { }
        console.log("web3................................", web3);
        return web3;
    }

    const chainIdCheck = async (configchainid) => {
        var Config = {};

        if (configchainid === network.MATIC.Chainid) {
            Config = network.MATIC;
        } else if (configchainid === network.ETH.Chainid) {
            Config = network.ETH;
        } else if (configchainid === network.CAM.Chainid) {
            Config = network.CAM;
        }

        const hexString = configchainid && configchainid.toString(16);
        if (window.ethereum) {
            try {
                // check if the chain to connect to is installed

                await window.ethereum.request({
                    method: "wallet_switchEthereumChain",
                    params: [{ chainId: "0x" + hexString }], // chainId must be in hexadecimal numbers
                });
                return true;
            } catch (error) {
                // This error code indicates that the chain has not been added to MetaMask
                // if it is not, then install it into the user MetaMask
                if (error.code === 4902) {
                    try {
                        await window.ethereum.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                {
                                    chainId: "0x" + hexString,
                                    rpcUrl: Config.RPC_URL,
                                },
                            ],
                        });
                        return true;
                    } catch (addError) {
                        console.error(addError);
                    }
                }
                console.error(error);
            }
        } else {
            // if no window.ethereum then MetaMask is not installed
            //console('MetaMask is not installed. Please consider installing it: https://metamask.io/download.html');
            return false;
        }
    };

    const serfeeall = () => {
        setmodalopen(true)
    }

    const disconnect = () => {
        Set_Accounts('')
    }

    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Edit Service Fee'} />
                      
                        <div className='common_page_scroller mt-5 pe-2'>
                        <div className="page_header">
                            <button className="btn btn-success" onClick={() => Accounts == '' ? getConnect() : disconnect()}><Link to="#">{Accounts != "" ? Accounts : "Connect"}</Link></button>
                        </div>
                            <form>
                                <div color="primary" className="addcategorys mt-3">
                                    <h4>
                                        View Service Fee <span className="font-weight-bold">(721 & 1155 must be SAME)</span>
                                        Note - This process takes <span className="font-weight-bold">Two Transactions</span> Please Confirm One by One
                                    </h4>
                                </div>
                                <div className="categorylisdt">
                                    <Row>
                                        <Col xs={12} sm={12} md={3} className='mt-4'>
                                            <div className="servicemod border py-3 px-2">
                                                <p className="text-center text-white">Buyer Fee - {buyer__fee}%</p>
                                                <p className="text-center text-white">Seller Fee - {seller__fee}%<span className="sertext"> Service fee in 721</span></p>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={3} className='mt-4'>
                                            <div className="servicemod border py-3 px-2">
                                                <p className="text-center text-white">Buyer Fee - {seller__fee}%</p>
                                                <p className="text-center text-white">Seller Fee - {seller__fee}%<span className="sertext"> Service fee in 1155</span></p>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={4} className='mt-4'>
                                            <div className='mt-0' style={{ width: '100%' }}>
                                                <label htmlFor="buyer_fee" className='mb-2'>Buyer Service Fee</label>
                                                <input
                                                  className='form-control'
                                                  placeholder='Buyer Service Fee'
                                                    type="text"
                                                    id="buyer_fee"
                                                    value={buyer__fee || ""}
                                                    onChange={(e) => onChangeFUnc(e)}
                                                    style={{ width: '100%' }}
                                                />
                                                {buyer__fee === 0 && <span className="text-danger mt-1">Check service fee</span>}
                                            </div>
                                            <div style={{ width: '100%', marginTop: '20px' }}>
                                                <label htmlFor="seller_fee" className='mb-2'>Seller Service Fee</label>
                                                <input
                                                  className='form-control'
                                                    type="text"
                                                    id="seller_fee"
                                                    value={seller__fee}
                                                    onChange={(e) => onChangeFUnc(e)}
                                                    style={{ width: '100%' }}
                                                />
                                                {seller__fee === 0 && <span className="text-danger mt-1">Check service fee</span>}
                                            </div>
                                        </Col>
                                    
                                    {UserAccountAddr && UserAccountAddr === owner_Get && (
                                        <>
                                            <Col xs={12} sm={12} md={3} style={{ marginTop: 20 }}>
                                                <button color="primary" onClick={() => serfeeall()}>
                                                    Edit Service Fee
                                                </button>
                                            </Col>
                                            <Col xs={12} sm={12} md={3} style={{ marginTop: 20 }}>
                                                <button color="primary" onClick={() => changeNetwork()}>
                                                    Switch Network
                                                </button>
                                            </Col>
                                        </>
                                    )}
                                    </Row>
                                </div>
                            </form>
                        </div>

                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default EditServiceFee